import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    margin: 'auto',
    maxWidth: 1000,
    justify: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(3),
  },
  grid: {
    justify: 'center',
    alignItems: 'center',
    padding: '2rem',
  },
  grid2: {
    justify: 'center',
    alignItems: 'center',
    padding: '2rem',
    backgroundColor: '#f4f4f4',
  },
  title: {
    color: '#EF3829',
  },
  subtitle: {
    color: 'gray',
    lineHeight: '1.2',
  },
  entityForm: {
    flexDirection: 'column',
    marginTop: '3rem',
  },
  userName: {
    color: 'gray',
    marginBottom: '1rem',
  },
}));
